// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "all-260527-2/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};